'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');

function getMerchantBoxHeading(merchantName, keyword1, brandName) {
  const defaultOptions = {
    tag: 'h2',
    attrs: { class: 'merchant-heading' },
  };

  if (keyword1) {
    return [
      {
        ...defaultOptions,
        0: brandName || merchantName,
        1: keyword1,
        2: h(DateTime, {
          value: Date.now(),
          format: 'MMMM YYYY',
        }),
      },
      'modules.merchant.ExpiredOffersSeoHeading',
    ];
  }
  return [
    {
      ...defaultOptions,
      0: merchantName,
      1: h(DateTime, {
        value: Date.now(),
        format: 'MMMM YYYY',
      }),
    },
    'modules.merchant.ExpiredOffersHeading',
  ];
}

function MerchantBoxHeading(merchantName, { keyword1, brandName }) {
  return h(
    Translate,
    ...getMerchantBoxHeading(merchantName, keyword1, brandName)
  );
}

module.exports = MerchantBoxHeading;
